var _regeneratorRuntime = require("@babel/runtime/regenerator");

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

(function (global, factory) {
  (typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(exports, require('vue'), require('lodash.get'), require('body-scroll-lock'), require('lodash.map')) : typeof define === 'function' && define.amd ? define(['exports', 'vue', 'lodash.get', 'body-scroll-lock', 'lodash.map'], factory) : (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.VueTailwind = {}, global.Vue, global.get, global.bodyScrollLock, global.map));
})(this, function (exports, Vue, get, bodyScrollLock, map) {
  'use strict';

  function _interopDefaultLegacy(e) {
    return e && _typeof(e) === 'object' && 'default' in e ? e : {
      'default': e
    };
  }

  var Vue__default = /*#__PURE__*/_interopDefaultLegacy(Vue);

  var get__default = /*#__PURE__*/_interopDefaultLegacy(get);

  var map__default = /*#__PURE__*/_interopDefaultLegacy(map);
  /* eslint-disable no-shadow */


  var HideReason;

  (function (HideReason) {
    HideReason["Outside"] = "outside";
    HideReason["Close"] = "close";
    HideReason["Esc"] = "esc";
    HideReason["Cancel"] = "cancel";
    HideReason["Ok"] = "ok";
    HideReason["Method"] = "method";
    HideReason["Value"] = "value";
  })(HideReason || (HideReason = {}));

  var DialogType;

  (function (DialogType) {
    DialogType["Alert"] = "alert";
    DialogType["Confirm"] = "confirm";
    DialogType["Prompt"] = "prompt";
  })(DialogType || (DialogType = {}));
  /*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
    Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** */


  function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P ? value : new P(function (resolve) {
        resolve(value);
      });
    }

    return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e) {
          reject(e);
        }
      }

      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e) {
          reject(e);
        }
      }

      function step(result) {
        result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
      }

      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  }

  var mergeClasses = function mergeClasses(classesA, classesB) {
    var a = classesA;
    var b = classesB; // Convert array of string classes to a single string

    if (Array.isArray(classesA) && classesA.every(function (className) {
      return typeof className === 'string' || !!className;
    })) {
      a = classesA.filter(function (className) {
        return !!className;
      }).join(' ');
    } // Convert array of string classes to a single string


    if (Array.isArray(classesB) && classesB.every(function (className) {
      return typeof className === 'string' || !!className;
    })) {
      b = classesB.filter(function (className) {
        return !!className;
      }).join(' ');
    }

    if (typeof a === 'string' && typeof b === 'string') {
      return "".concat(a, " ").concat(b);
    }

    if (typeof a === 'string' && Array.isArray(b)) {
      return [a].concat(b);
    }

    if (typeof b === 'string' && Array.isArray(a)) {
      return a.concat([b]);
    }

    if (Array.isArray(a) && Array.isArray(b)) {
      return a.concat(b);
    }

    return [a, b];
  };

  var Component = Vue__default['default'].extend({
    props: {
      classes: {
        type: [String, Array, Object],
        default: undefined
      },
      fixedClasses: {
        type: [String, Array, Object],
        default: undefined
      },
      variants: {
        type: Object,
        default: undefined
      },
      variant: {
        type: [String, Object],
        default: undefined
      }
    },
    computed: {
      componentClass: function componentClass() {
        return this.getElementCssClass();
      },
      activeVariant: function activeVariant() {
        var _this = this;

        if (!this.variant) {
          return undefined;
        }

        if (_typeof(this.variant) === 'object') {
          var truthyVariant = Object.keys(this.variant).find(function (variant) {
            return !!_this.variant[variant];
          });
          return truthyVariant || undefined;
        }

        return this.variant;
      }
    },
    methods: {
      getElementCssClass: function getElementCssClass(elementName) {
        var defaultClasses = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        var classes;

        if (elementName) {
          if (this.activeVariant) {
            var elementVariant = get__default['default'](this.variants, "".concat(this.activeVariant, ".").concat(elementName)); // If the variant exists but not for the element fallback to the default

            if (elementVariant === undefined && get__default['default'](this.variants, this.activeVariant) !== undefined) {
              classes = get__default['default'](this.classes, elementName, defaultClasses);
            } else {
              classes = elementVariant === undefined ? defaultClasses : elementVariant;
            }
          } else {
            classes = get__default['default'](this.classes, elementName, defaultClasses);
          }

          var fixedClasses = get__default['default'](this.fixedClasses, elementName);

          if (fixedClasses) {
            return mergeClasses(fixedClasses, classes);
          }

          return classes;
        }

        if (this.activeVariant) {
          classes = get__default['default'](this.variants, this.activeVariant, defaultClasses);
        } else {
          classes = this.classes === undefined ? defaultClasses : this.classes;
        }

        if (this.fixedClasses) {
          return mergeClasses(this.fixedClasses, classes);
        }

        return classes;
      }
    }
  });
  /* eslint-disable no-shadow */

  var Key;

  (function (Key) {
    Key[Key["LEFT"] = 37] = "LEFT";
    Key[Key["UP"] = 38] = "UP";
    Key[Key["RIGHT"] = 39] = "RIGHT";
    Key[Key["DOWN"] = 40] = "DOWN";
    Key[Key["ENTER"] = 13] = "ENTER";
    Key[Key["ESC"] = 27] = "ESC";
    Key[Key["SPACE"] = 32] = "SPACE";
    Key[Key["BACKSPACE"] = 8] = "BACKSPACE";
  })(Key || (Key = {}));

  var Key$1 = Key;

  var guessOptionValue = function guessOptionValue(option, valueAttribute) {
    if (valueAttribute) {
      return get__default['default'](option, valueAttribute);
    }

    return get__default['default'](option, 'value', get__default['default'](option, 'id', get__default['default'](option, 'text')));
  };

  var guessOptionText = function guessOptionText(option, textAttribute) {
    if (textAttribute) {
      return get__default['default'](option, textAttribute);
    }

    return get__default['default'](option, 'text', get__default['default'](option, 'label'));
  };

  var normalizeOption = function normalizeOption(option, textAttribute, valueAttribute) {
    if (typeof option === 'string' || typeof option === 'number' || typeof option === 'boolean') {
      return {
        value: option,
        text: option,
        raw: option
      };
    }

    if (option.children) {
      var children = option.children.map(function (childOption) {
        return normalizeOption(childOption);
      });
      return {
        value: guessOptionValue(option, valueAttribute),
        text: guessOptionText(option, textAttribute),
        children: children
      };
    }

    var normalizedOption = {
      value: guessOptionValue(option, valueAttribute),
      text: guessOptionText(option, textAttribute),
      raw: option
    };

    if (option.disabled !== undefined) {
      normalizedOption.disabled = option.disabled;
    }

    return normalizedOption;
  };

  var normalizeOptions = function normalizeOptions(options, textAttribute, valueAttribute) {
    if (!options) {
      return [];
    }

    if (Array.isArray(options)) {
      return options.map(function (option) {
        return normalizeOption(option, textAttribute, valueAttribute);
      });
    }

    return map__default['default'](options, function (option, key) {
      return {
        value: key,
        text: option
      };
    });
  };

  var uniqid = function uniqid() {
    return Math.random().toString(36).substring(7);
  };

  var TDialogOverlayWrapperTransitionDialogContentInput = Vue__default['default'].extend({
    name: 'TDialogOverlayWrapperTransitionDialogContentInput',
    props: {
      getElementCssClass: {
        type: Function,
        required: true
      },
      inputAttributes: {
        type: Object,
        default: undefined
      },
      inputType: {
        type: String,
        required: true
      },
      inputValue: {
        type: [String, Array],
        default: undefined
      },
      inputPlaceholder: {
        type: String,
        default: undefined
      },
      inputOptions: {
        type: [Array, Object],
        default: undefined
      }
    },
    data: function data() {
      return {
        errorMessage: null
      };
    },
    mounted: function mounted() {
      this.inputHandler();
    },
    methods: {
      getInputValue: function getInputValue() {
        var input = this.$refs.input;

        if (!input) {
          return undefined;
        }

        var inputName = input.name;

        if (input.type === 'radio') {
          var checkedRadio = this.$refs.inputWrapper.querySelector("input[name=\"".concat(inputName, "\"]:checked"));
          return checkedRadio ? checkedRadio.value : null;
        }

        if (input.type === 'checkbox') {
          if (this.inputOptions) {
            var checkedCheckboxes = this.$refs.inputWrapper.querySelectorAll("input[name=\"".concat(inputName, "\"]:checked"));
            var inititalValue = Array.from(checkedCheckboxes).map(function (checkbox) {
              return checkbox.value;
            });
            return inititalValue;
          }

          return input.checked ? input.value : null;
        }

        return input.value;
      },
      inputHandler: function inputHandler() {
        this.errorMessage = null;
        var inputValue = this.getInputValue();
        this.$emit('input', inputValue);
      }
    },
    render: function render(createElement) {
      var _this2 = this;

      var input;

      if (this.inputType === 'select') {
        var options = normalizeOptions(this.inputOptions || []).map(function (option) {
          var isSelected = _this2.inputValue === option.value;
          return createElement('option', {
            domProps: {
              value: option.value,
              selected: isSelected
            }
          }, String(option.text));
        });
        input = createElement('select', {
          class: this.getElementCssClass('select'),
          ref: 'input',
          attrs: Object.assign({
            name: 'input'
          }, this.inputAttributes),
          on: {
            change: this.inputHandler
          }
        }, options);
      } else if (this.inputType === 'radio') {
        input = normalizeOptions(this.inputOptions || []).map(function (option) {
          var isChecked = _this2.inputValue === option.value;
          return createElement('label', {
            class: _this2.getElementCssClass('radioWrapper'),
            attrs: {
              for: "input-".concat(String(option.value))
            }
          }, [createElement('input', {
            class: _this2.getElementCssClass('radio'),
            ref: 'input',
            attrs: Object.assign({
              type: 'radio',
              name: 'input',
              id: "input-".concat(String(option.value)),
              value: option.value,
              checked: isChecked
            }, _this2.inputAttributes),
            on: {
              change: _this2.inputHandler
            }
          }), createElement('span', {
            class: _this2.getElementCssClass('radioText')
          }, String(option.text))]);
        });
      } else if (this.inputType === 'checkbox') {
        if (this.inputOptions) {
          input = normalizeOptions(this.inputOptions || []).map(function (option) {
            var isChecked = Array.isArray(_this2.inputValue) ? _this2.inputValue.includes(option.value) : _this2.inputValue === option.value;
            return createElement('label', {
              class: _this2.getElementCssClass('checkboxWrapper'),
              attrs: {
                for: "input-".concat(String(option.value))
              }
            }, [createElement('input', {
              class: _this2.getElementCssClass('checkbox'),
              ref: 'input',
              attrs: Object.assign({
                type: 'checkbox',
                name: 'input[]',
                id: "input-".concat(String(option.value)),
                value: option.value,
                checked: isChecked
              }, _this2.inputAttributes),
              on: {
                change: _this2.inputHandler
              }
            }), createElement('span', {
              class: _this2.getElementCssClass('checkboxText')
            }, String(option.text))]);
          });
        } else {
          var id = uniqid();
          input = createElement('label', {
            class: this.getElementCssClass('checkboxWrapper'),
            attrs: {
              for: "input-".concat(id)
            }
          }, [createElement('input', {
            class: this.getElementCssClass('checkbox'),
            ref: 'input',
            attrs: Object.assign({
              type: 'checkbox',
              name: 'input',
              id: "input-".concat(id),
              value: this.inputValue
            }, this.inputAttributes),
            on: {
              change: this.inputHandler
            }
          }), createElement('span', {
            class: this.getElementCssClass('checkboxText')
          }, this.inputPlaceholder ? String(this.inputPlaceholder) : '')]);
        }
      } else {
        input = createElement('input', {
          class: this.getElementCssClass('input'),
          ref: 'input',
          domProps: {
            value: this.inputValue
          },
          attrs: Object.assign({
            name: 'input',
            type: this.inputType,
            placeholder: this.inputPlaceholder
          }, this.inputAttributes),
          on: {
            input: this.inputHandler
          }
        });
      }

      return createElement('div', {
        ref: 'inputWrapper',
        class: this.getElementCssClass('inputWrapper')
      }, Array.isArray(input) ? input : [input]);
    }
  });
  var TDialogOverlayWrapperTransitionDialogContent = Vue__default['default'].extend({
    name: 'TDialogOverlayWrapperTransitionDialogContent',
    props: {
      getElementCssClass: {
        type: Function,
        required: true
      },
      titleTag: {
        type: String,
        required: true
      },
      title: {
        type: String,
        default: undefined
      },
      textTag: {
        type: String,
        required: true
      },
      text: {
        type: String,
        default: undefined
      },
      type: {
        type: String,
        required: true
      },
      inputAttributes: {
        type: Object,
        default: undefined
      },
      inputType: {
        type: String,
        required: true
      },
      inputValue: {
        type: [String, Array],
        default: undefined
      },
      inputPlaceholder: {
        type: String,
        default: undefined
      },
      inputOptions: {
        type: [Array, Object],
        default: undefined
      },
      errorMessage: {
        type: String,
        required: true
      }
    },
    render: function render(createElement) {
      var _this3 = this;

      var subElements = [];

      if (this.title || this.$scopedSlots.title) {
        if (this.$scopedSlots.title) {
          subElements.push(createElement('div', {
            class: this.getElementCssClass('titleWrapper')
          }, [this.$scopedSlots.title({
            class: this.getElementCssClass('title')
          })]));
        } else {
          subElements.push(createElement('div', {
            class: this.getElementCssClass('titleWrapper')
          }, [createElement(this.titleTag, {
            class: this.getElementCssClass('title')
          }, this.title || '')]));
        }
      }

      if (this.$slots.default) {
        subElements.push(createElement('div', {
          class: this.getElementCssClass('textWrapper')
        }, this.$slots.default));
      } else if (this.text) {
        subElements.push(createElement('div', {
          class: this.getElementCssClass('textWrapper')
        }, this.text ? [createElement(this.textTag, {
          class: this.getElementCssClass('text')
        }, this.text)] : undefined));
      }

      if (this.type === DialogType.Prompt) {
        subElements.push(createElement(TDialogOverlayWrapperTransitionDialogContentInput, {
          props: {
            getElementCssClass: this.getElementCssClass,
            inputAttributes: this.inputAttributes,
            inputType: this.inputType,
            inputValue: this.inputValue,
            inputOptions: this.inputOptions,
            inputPlaceholder: this.inputPlaceholder
          },
          on: {
            input: function input(val) {
              return _this3.$emit('input', val);
            }
          }
        }));
      }

      if (this.errorMessage && typeof this.errorMessage === 'string') {
        subElements.push(createElement('div', {
          class: this.getElementCssClass('errorMessage')
        }, this.errorMessage));
      }

      return createElement('div', {
        class: this.getElementCssClass('content')
      }, subElements);
    }
  });
  var IconName;

  (function (IconName) {
    IconName["Success"] = "success";
    IconName["Error"] = "error";
    IconName["Warning"] = "warning";
    IconName["Info"] = "info";
    IconName["Question"] = "question";
  })(IconName || (IconName = {}));

  function getHtmlSvgPath(iconName) {
    if (!iconName) {
      return undefined;
    }

    var icons = {};
    icons[IconName.Success] = '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>';
    icons[IconName.Error] = '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>';
    icons[IconName.Warning] = '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path>';
    icons[IconName.Info] = '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>';
    icons[IconName.Question] = '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>';
    return icons[iconName];
  }

  var TDialogOverlayWrapperTransitionDialogIcon = Vue__default['default'].extend({
    name: 'TDialogOverlayWrapperTransitionDialogIcon',
    props: {
      getElementCssClass: {
        type: Function,
        required: true
      },
      icon: {
        type: String,
        default: undefined
      }
    },
    render: function render(createElement) {
      if (this.$scopedSlots.icon) {
        return createElement('div', {
          class: this.getElementCssClass('iconWrapper')
        }, [this.$scopedSlots.icon({})]);
      }

      var htmlSvgPath = getHtmlSvgPath(this.icon);

      if (!htmlSvgPath) {
        return createElement();
      }

      return createElement('div', {
        class: this.getElementCssClass('iconWrapper')
      }, [createElement('svg', {
        class: this.getElementCssClass('icon'),
        attrs: {
          fill: 'none',
          stroke: 'currentColor',
          viewBox: '0 0 24 24',
          xmlns: 'http://www.w3.org/2000/svg'
        },
        domProps: {
          innerHTML: htmlSvgPath
        }
      })]);
    }
  });
  var TDialogOverlayWrapperTransitionDialogClose = Vue__default['default'].extend({
    name: 'TDialogOverlayWrapperTransitionDialogClose',
    props: {
      getElementCssClass: {
        type: Function,
        required: true
      },
      showCloseButton: {
        type: Boolean,
        required: true
      }
    },
    render: function render(createElement) {
      var _this4 = this;

      if (!this.showCloseButton) {
        return createElement();
      }

      if (this.$scopedSlots.closeButton) {
        return createElement('button', {
          class: this.getElementCssClass('close'),
          attrs: {
            type: 'button'
          },
          on: {
            click: function click(e) {
              return _this4.$emit('dismiss', e);
            }
          }
        }, [this.$scopedSlots.closeButton({})]);
      }

      return createElement('button', {
        class: this.getElementCssClass('close'),
        attrs: {
          type: 'button'
        },
        on: {
          click: function click(e) {
            return _this4.$emit('dismiss', e);
          }
        }
      }, [createElement('svg', {
        attrs: {
          fill: 'currentColor',
          xmlns: 'http://www.w3.org/2000/svg',
          viewBox: '0 0 20 20'
        },
        class: this.getElementCssClass('closeIcon')
      }, [createElement('path', {
        attrs: {
          'clip-rule': 'evenodd',
          'fill-rule': 'evenodd',
          d: 'M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z'
        }
      })])]);
    }
  });
  var TDialogOverlayWrapperTransitionDialogLoader = Vue__default['default'].extend({
    name: 'TDialogOverlayWrapperTransitionDialogLoader',
    props: {
      getElementCssClass: {
        type: Function,
        required: true
      },
      busy: {
        type: Boolean,
        required: true
      }
    },
    render: function render(createElement) {
      if (!this.busy) {
        return createElement();
      }

      if (this.$scopedSlots.loader) {
        return createElement('div', {
          class: this.getElementCssClass('busyWrapper')
        }, [this.$scopedSlots.loader({})]);
      }

      return createElement('div', {
        class: this.getElementCssClass('busyWrapper')
      }, [createElement('svg', {
        attrs: {
          xmlns: 'http://www.w3.org/2000/svg',
          width: 32,
          height: 32,
          viewBox: '0 0 32 32'
        },
        class: this.getElementCssClass('busyIcon')
      }, [createElement('g', {
        attrs: {
          transform: 'scale(0.03125 0.03125)'
        }
      }, [createElement('path', {
        attrs: {
          d: 'M512 1024c-136.76 0-265.334-53.258-362.040-149.96-96.702-96.706-149.96-225.28-149.96-362.040 0-96.838 27.182-191.134 78.606-272.692 50-79.296 120.664-143.372 204.356-185.3l43 85.832c-68.038 34.084-125.492 86.186-166.15 150.67-41.746 66.208-63.812 142.798-63.812 221.49 0 229.382 186.618 416 416 416s416-186.618 416-416c0-78.692-22.066-155.282-63.81-221.49-40.66-64.484-98.114-116.584-166.15-150.67l43-85.832c83.692 41.928 154.358 106.004 204.356 185.3 51.422 81.558 78.604 175.854 78.604 272.692 0 136.76-53.258 265.334-149.96 362.040-96.706 96.702-225.28 149.96-362.040 149.96z'
        }
      })])])]);
    }
  });
  var TDialogOverlayWrapperTransitionDialogButtons = Vue__default['default'].extend({
    name: 'TDialogOverlayWrapperTransitionDialogButtons',
    props: {
      getElementCssClass: {
        type: Function,
        required: true
      },
      cancelButtonText: {
        type: String,
        required: true
      },
      cancelButtonAriaLabel: {
        type: String,
        default: undefined
      },
      okButtonText: {
        type: String,
        required: true
      },
      okButtonAriaLabel: {
        type: String,
        default: undefined
      },
      type: {
        type: String,
        required: true
      }
    },
    methods: {
      cancel: function cancel(e) {
        this.$emit('cancel', e);
      },
      ok: function ok(e) {
        this.$emit('submit', e);
      }
    },
    render: function render(createElement) {
      var type = this.type;

      if (this.$scopedSlots.buttons) {
        return createElement('div', {
          class: this.getElementCssClass('buttons')
        }, [this.$scopedSlots.buttons({
          cancelButtonAriaLabel: this.cancelButtonAriaLabel,
          okButtonAriaLabel: this.okButtonAriaLabel,
          cancelButtonText: this.cancelButtonText,
          okButtonText: this.okButtonText,
          okButtonClass: this.getElementCssClass('okButton'),
          cancelButtonClass: this.getElementCssClass('cancelButton'),
          dialogType: type,
          cancel: this.cancel,
          ok: this.ok
        })]);
      }

      var subElements = [];
      var buttons = {
        cancel: createElement('button', {
          attrs: {
            type: 'button',
            'aria-label': this.cancelButtonAriaLabel
          },
          class: this.getElementCssClass('cancelButton'),
          on: {
            click: this.cancel
          }
        }, this.cancelButtonText),
        ok: createElement('button', {
          attrs: {
            type: 'button',
            'aria-label': this.okButtonAriaLabel
          },
          class: this.getElementCssClass('okButton'),
          on: {
            click: this.ok
          }
        }, this.okButtonText)
      };

      if (type === DialogType.Alert) {
        subElements.push(buttons.ok);
      } else if (type === DialogType.Confirm || type === DialogType.Prompt) {
        subElements.push(buttons.cancel);
        subElements.push(buttons.ok);
      }

      return createElement('div', {
        class: this.getElementCssClass('buttons')
      }, subElements);
    }
  });
  var TDialogOverlayWrapperTransitionDialog = Vue__default['default'].extend({
    name: 'TDialogOverlayWrapperTransitionDialog',
    props: {
      getElementCssClass: {
        type: Function,
        required: true
      },
      dialogShow: {
        type: Boolean,
        required: true
      },
      titleTag: {
        type: String,
        required: true
      },
      title: {
        type: String,
        default: undefined
      },
      icon: {
        type: String,
        default: undefined
      },
      textTag: {
        type: String,
        required: true
      },
      text: {
        type: String,
        default: undefined
      },
      cancelButtonText: {
        type: String,
        required: true
      },
      cancelButtonAriaLabel: {
        type: String,
        default: undefined
      },
      okButtonText: {
        type: String,
        required: true
      },
      okButtonAriaLabel: {
        type: String,
        default: undefined
      },
      showCloseButton: {
        type: Boolean,
        required: true
      },
      preConfirm: {
        type: Function,
        default: undefined
      },
      inputAttributes: {
        type: Object,
        default: undefined
      },
      inputType: {
        type: String,
        required: true
      },
      inputValidator: {
        type: Function,
        default: undefined
      },
      inputValue: {
        type: [String, Array],
        default: undefined
      },
      inputOptions: {
        type: [Array, Object],
        default: undefined
      },
      inputPlaceholder: {
        type: String,
        default: undefined
      },
      type: {
        type: String,
        required: true
      }
    },
    data: function data() {
      return {
        currentValue: null,
        errorMessage: '',
        busy: false
      };
    },
    methods: {
      submitHandler: function submitHandler(e) {
        var _this5 = this;

        return this.resolveParam(this.inputValidator, this.currentValue).then(function (errorMessage) {
          if (errorMessage && typeof errorMessage === 'string') {
            _this5.errorMessage = String(errorMessage);
            return;
          }

          _this5.resolveParam(_this5.preConfirm, _this5.currentValue).then(function (response) {
            _this5.$emit('submit', e, _this5.currentValue, response);
          }).catch(function (error) {
            _this5.$emit('submit-error', e, _this5.currentValue, error);
          }).then(function () {
            _this5.busy = false;
          });
        }).catch(function (errorMessage) {
          _this5.errorMessage = String(errorMessage);
        });
      },
      inputHandler: function inputHandler(input) {
        this.errorMessage = '';
        this.currentValue = input;
      },
      resolveParam: function resolveParam(resolvable, input) {
        if (typeof resolvable === 'function') {
          var result = resolvable(input);

          if (result instanceof Promise) {
            this.busy = true;
            return result;
          }

          return new Promise(function (resolve) {
            resolve(result);
          });
        }

        return new Promise(function (resolve) {
          return resolve();
        });
      }
    },
    render: function render(createElement) {
      var _this6 = this;

      if (!this.dialogShow) {
        return createElement();
      }

      return createElement('div', {
        ref: 'dialog',
        class: this.getElementCssClass('dialog')
      }, [createElement(TDialogOverlayWrapperTransitionDialogLoader, {
        props: {
          getElementCssClass: this.getElementCssClass,
          busy: this.busy
        },
        scopedSlots: {
          loader: this.$scopedSlots.loader
        }
      }), createElement(TDialogOverlayWrapperTransitionDialogClose, {
        props: {
          getElementCssClass: this.getElementCssClass,
          showCloseButton: this.showCloseButton
        },
        on: {
          dismiss: function dismiss(e) {
            return _this6.$emit('dismiss', e);
          }
        },
        scopedSlots: {
          closeButton: this.$scopedSlots.closeButton
        }
      }), createElement('div', {
        ref: 'body',
        class: this.getElementCssClass('body')
      }, [createElement(TDialogOverlayWrapperTransitionDialogIcon, {
        props: {
          getElementCssClass: this.getElementCssClass,
          icon: this.icon
        },
        scopedSlots: {
          icon: this.$scopedSlots.icon
        }
      }), createElement(TDialogOverlayWrapperTransitionDialogContent, {
        props: {
          getElementCssClass: this.getElementCssClass,
          titleTag: this.titleTag,
          title: this.title,
          textTag: this.textTag,
          text: this.text,
          type: this.type,
          inputAttributes: this.inputAttributes,
          inputType: this.inputType,
          inputValue: this.inputValue,
          inputOptions: this.inputOptions,
          inputPlaceholder: this.inputPlaceholder,
          errorMessage: this.errorMessage
        },
        on: {
          input: this.inputHandler
        },
        scopedSlots: {
          title: this.$scopedSlots.title
        }
      }, this.$slots.default)]), createElement(TDialogOverlayWrapperTransitionDialogButtons, {
        props: {
          getElementCssClass: this.getElementCssClass,
          type: this.type,
          cancelButtonText: this.cancelButtonText,
          cancelButtonAriaLabel: this.cancelButtonAriaLabel,
          okButtonText: this.okButtonText,
          okButtonAriaLabel: this.okButtonAriaLabel
        },
        on: {
          cancel: function cancel(e) {
            return _this6.$emit('cancel', e);
          },
          submit: this.submitHandler
        },
        scopedSlots: {
          buttons: this.$scopedSlots.buttons
        }
      })]);
    }
  });
  var TDialogOverlayWrapperTransition = Vue__default['default'].extend({
    name: 'TDialogOverlayWrapperTransition',
    props: {
      getElementCssClass: {
        type: Function,
        required: true
      },
      dialogShow: {
        type: Boolean,
        required: true
      },
      titleTag: {
        type: String,
        required: true
      },
      title: {
        type: String,
        default: undefined
      },
      icon: {
        type: String,
        default: undefined
      },
      textTag: {
        type: String,
        required: true
      },
      text: {
        type: String,
        default: undefined
      },
      cancelButtonText: {
        type: String,
        required: true
      },
      cancelButtonAriaLabel: {
        type: String,
        default: undefined
      },
      okButtonText: {
        type: String,
        required: true
      },
      okButtonAriaLabel: {
        type: String,
        default: undefined
      },
      showCloseButton: {
        type: Boolean,
        required: true
      },
      preConfirm: {
        type: Function,
        default: undefined
      },
      inputAttributes: {
        type: Object,
        default: undefined
      },
      inputType: {
        type: String,
        required: true
      },
      inputValidator: {
        type: Function,
        default: undefined
      },
      inputValue: {
        type: [String, Array],
        default: undefined
      },
      inputOptions: {
        type: [Array, Object],
        default: undefined
      },
      inputPlaceholder: {
        type: String,
        default: undefined
      },
      type: {
        type: String,
        required: true
      }
    },
    render: function render(createElement) {
      var _this7 = this;

      return createElement('transition', {
        props: {
          enterClass: this.getElementCssClass('enterClass'),
          enterActiveClass: this.getElementCssClass('enterActiveClass'),
          enterToClass: this.getElementCssClass('enterToClass'),
          leaveClass: this.getElementCssClass('leaveClass'),
          leaveActiveClass: this.getElementCssClass('leaveActiveClass'),
          leaveToClass: this.getElementCssClass('leaveToClass')
        }
      }, [createElement(TDialogOverlayWrapperTransitionDialog, {
        props: {
          getElementCssClass: this.getElementCssClass,
          dialogShow: this.dialogShow,
          titleTag: this.titleTag,
          title: this.title,
          icon: this.icon,
          textTag: this.textTag,
          text: this.text,
          cancelButtonText: this.cancelButtonText,
          cancelButtonAriaLabel: this.cancelButtonAriaLabel,
          okButtonText: this.okButtonText,
          okButtonAriaLabel: this.okButtonAriaLabel,
          showCloseButton: this.showCloseButton,
          preConfirm: this.preConfirm,
          inputAttributes: this.inputAttributes,
          inputType: this.inputType,
          inputValidator: this.inputValidator,
          inputValue: this.inputValue,
          inputOptions: this.inputOptions,
          inputPlaceholder: this.inputPlaceholder,
          type: this.type
        },
        scopedSlots: this.$scopedSlots,
        on: {
          dismiss: function dismiss(e) {
            return _this7.$emit('dismiss', e);
          },
          cancel: function cancel(e) {
            return _this7.$emit('cancel', e);
          },
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          submit: function submit(e, input, response) {
            return _this7.$emit('submit', e, input, response);
          },
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          'submit-error': function submitError(e, input, error) {
            return _this7.$emit('submit-error', e, input, error);
          }
        }
      }, this.$slots.default)]);
    }
  });
  var TDialogOverlayWrapper = Vue__default['default'].extend({
    name: 'TDialogOverlayWrapper',
    props: {
      getElementCssClass: {
        type: Function,
        required: true
      },
      dialogShow: {
        type: Boolean,
        required: true
      },
      titleTag: {
        type: String,
        required: true
      },
      title: {
        type: String,
        default: undefined
      },
      icon: {
        type: String,
        default: undefined
      },
      textTag: {
        type: String,
        required: true
      },
      text: {
        type: String,
        default: undefined
      },
      cancelButtonText: {
        type: String,
        required: true
      },
      cancelButtonAriaLabel: {
        type: String,
        default: undefined
      },
      okButtonText: {
        type: String,
        required: true
      },
      okButtonAriaLabel: {
        type: String,
        default: undefined
      },
      showCloseButton: {
        type: Boolean,
        required: true
      },
      preConfirm: {
        type: Function,
        default: undefined
      },
      inputAttributes: {
        type: Object,
        default: undefined
      },
      inputType: {
        type: String,
        required: true
      },
      inputValidator: {
        type: Function,
        default: undefined
      },
      inputValue: {
        type: [String, Array],
        default: undefined
      },
      inputOptions: {
        type: [Array, Object],
        default: undefined
      },
      inputPlaceholder: {
        type: String,
        default: undefined
      },
      type: {
        type: String,
        required: true
      }
    },
    render: function render(createElement) {
      var _this8 = this;

      return createElement('div', {
        ref: 'wrapper',
        class: this.getElementCssClass('wrapper')
      }, [createElement(TDialogOverlayWrapperTransition, {
        props: {
          type: this.type,
          dialogShow: this.dialogShow,
          getElementCssClass: this.getElementCssClass,
          titleTag: this.titleTag,
          title: this.title,
          icon: this.icon,
          textTag: this.textTag,
          text: this.text,
          cancelButtonText: this.cancelButtonText,
          cancelButtonAriaLabel: this.cancelButtonAriaLabel,
          okButtonText: this.okButtonText,
          okButtonAriaLabel: this.okButtonAriaLabel,
          showCloseButton: this.showCloseButton,
          preConfirm: this.preConfirm,
          inputAttributes: this.inputAttributes,
          inputType: this.inputType,
          inputValidator: this.inputValidator,
          inputValue: this.inputValue,
          inputOptions: this.inputOptions,
          inputPlaceholder: this.inputPlaceholder
        },
        scopedSlots: this.$scopedSlots,
        on: {
          dismiss: function dismiss(e) {
            return _this8.$emit('dismiss', e);
          },
          cancel: function cancel(e) {
            return _this8.$emit('cancel', e);
          },
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          submit: function submit(e, input, response) {
            return _this8.$emit('submit', e, input, response);
          },
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          'submit-error': function submitError(e, input, error) {
            return _this8.$emit('submit-error', e, input, error);
          }
        }
      }, this.$slots.default)]);
    }
  });
  var TDialogOverlay = Vue__default['default'].extend({
    name: 'TDialogOverlay',
    props: {
      getElementCssClass: {
        type: Function,
        required: true
      },
      overlayShow: {
        type: Boolean,
        required: true
      },
      dialogShow: {
        type: Boolean,
        required: true
      },
      titleTag: {
        type: String,
        required: true
      },
      title: {
        type: String,
        default: undefined
      },
      textTag: {
        type: String,
        required: true
      },
      text: {
        type: String,
        default: undefined
      },
      icon: {
        type: String,
        default: undefined
      },
      cancelButtonText: {
        type: String,
        required: true
      },
      cancelButtonAriaLabel: {
        type: String,
        default: undefined
      },
      okButtonText: {
        type: String,
        required: true
      },
      okButtonAriaLabel: {
        type: String,
        default: undefined
      },
      showCloseButton: {
        type: Boolean,
        required: true
      },
      preConfirm: {
        type: Function,
        default: undefined
      },
      inputAttributes: {
        type: Object,
        default: undefined
      },
      inputType: {
        type: String,
        required: true
      },
      inputValidator: {
        type: Function,
        default: undefined
      },
      inputValue: {
        type: [String, Array],
        default: undefined
      },
      inputOptions: {
        type: [Array, Object],
        default: undefined
      },
      inputPlaceholder: {
        type: String,
        default: undefined
      },
      type: {
        type: String,
        default: null
      }
    },
    methods: {
      clickHandler: function clickHandler(e) {
        if (e.target !== this.$el) {
          return;
        }

        this.$emit('outside-click', e);
      },
      keyupHandler: function keyupHandler(e) {
        this.$emit('keyup', e);
      },
      focus: function focus() {
        var overlay = this.$el;

        if (overlay && overlay.focus) {
          overlay.focus();
        }
      },
      enableBodyScroll: function enableBodyScroll() {
        var mdl = this.$el;
        bodyScrollLock.enableBodyScroll(mdl);
      },
      disableBodyScroll: function disableBodyScroll() {
        var mdl = this.$el;
        bodyScrollLock.disableBodyScroll(mdl, {
          reserveScrollBarGap: true
        });
      }
    },
    render: function render(createElement) {
      var _this9 = this;

      if (!this.overlayShow) {
        return createElement();
      }

      return createElement('div', {
        attrs: {
          tabindex: 0
        },
        class: this.getElementCssClass('overlay'),
        on: {
          keyup: this.keyupHandler,
          click: this.clickHandler
        }
      }, [createElement(TDialogOverlayWrapper, {
        props: {
          type: this.type,
          getElementCssClass: this.getElementCssClass,
          dialogShow: this.dialogShow,
          titleTag: this.titleTag,
          title: this.title,
          icon: this.icon,
          textTag: this.textTag,
          text: this.text,
          cancelButtonText: this.cancelButtonText,
          cancelButtonAriaLabel: this.cancelButtonAriaLabel,
          okButtonText: this.okButtonText,
          okButtonAriaLabel: this.okButtonAriaLabel,
          showCloseButton: this.showCloseButton,
          preConfirm: this.preConfirm,
          inputAttributes: this.inputAttributes,
          inputType: this.inputType,
          inputValidator: this.inputValidator,
          inputValue: this.inputValue,
          inputOptions: this.inputOptions,
          inputPlaceholder: this.inputPlaceholder
        },
        scopedSlots: this.$scopedSlots,
        on: {
          dismiss: function dismiss(e) {
            return _this9.$emit('dismiss', e);
          },
          cancel: function cancel(e) {
            return _this9.$emit('cancel', e);
          },
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          submit: function submit(e, input, response) {
            return _this9.$emit('submit', e, input, response);
          },
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          'submit-error': function submitError(e, input, error) {
            return _this9.$emit('submit-error', e, input, error);
          }
        }
      }, this.$slots.default)]);
    }
  });

  var getInitialData = function getInitialData(vm) {
    return {
      overlayShow: vm.value,
      dialogShow: vm.value,
      params: undefined,
      preventAction: false,
      hideReason: undefined,
      input: undefined,
      resolve: null,
      reject: null,
      preConfirmResponse: undefined,
      preConfirmError: undefined
    };
  };

  var TDialog = Component.extend({
    name: 'TDialog',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      name: {
        type: String,
        default: undefined
      },
      titleTag: {
        type: String,
        default: 'h3'
      },
      title: {
        type: String,
        default: undefined
      },
      icon: {
        type: String,
        default: undefined
      },
      textTag: {
        type: String,
        default: 'p'
      },
      text: {
        type: String,
        default: undefined
      },
      clickToClose: {
        type: Boolean,
        default: true
      },
      escToClose: {
        type: Boolean,
        default: true
      },
      cancelButtonText: {
        type: String,
        default: 'Cancel'
      },
      cancelButtonAriaLabel: {
        type: String,
        default: undefined
      },
      okButtonText: {
        type: String,
        default: 'OK'
      },
      okButtonAriaLabel: {
        type: String,
        default: undefined
      },
      showCloseButton: {
        type: Boolean,
        default: false
      },
      disableBodyScroll: {
        type: Boolean,
        default: true
      },
      focusOnOpen: {
        type: Boolean,
        default: true
      },
      preConfirm: {
        type: Function,
        default: undefined
      },
      inputAttributes: {
        type: Object,
        default: undefined
      },
      inputType: {
        type: String,
        default: 'text'
      },
      inputValidator: {
        type: Function,
        default: undefined
      },
      inputValue: {
        type: [String, Array],
        default: undefined
      },
      inputOptions: {
        type: [Array, Object],
        default: undefined
      },
      inputPlaceholder: {
        type: String,
        default: undefined
      },
      type: {
        type: String,
        default: DialogType.Alert
      },
      fixedClasses: {
        type: Object,
        default: function _default() {
          return {
            overlay: 'overflow-auto scrolling-touch left-0 top-0 bottom-0 right-0 w-full h-full fixed',
            wrapper: 'relative mx-auto',
            modal: 'overflow-visible relative ',
            close: 'flex items-center justify-center',
            dialog: 'overflow-visible relative'
          };
        }
      },
      classes: {
        type: Object,
        default: function _default() {
          return {
            close: 'bg-gray-100 text-gray-600 rounded-full absolute right-0 top-0 -m-3 h-8 w-8 transition duration-100 ease-in-out hover:bg-gray-200 focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50',
            closeIcon: 'fill-current h-4 w-4',
            overlay: 'z-40 bg-black bg-opacity-50',
            wrapper: 'z-50 max-w-lg px-3 py-12',
            dialog: 'bg-white shadow rounded text-left',
            body: 'p-3 space-y-3',
            buttons: 'p-3 flex space-x-4 justify-center bg-gray-100 rounded-b',
            iconWrapper: 'bg-gray-100 flex flex-shrink-0 h-12 items-center justify-center rounded-full w-12 mx-auto',
            icon: 'w-6 h-6 text-gray-500',
            content: 'w-full flex justify-center flex-col',
            titleWrapper: '',
            title: 'text-lg font-semibold text-center',
            textWrapper: 'text-left w-full',
            text: '',
            cancelButton: 'block px-4 py-2 transition duration-100 ease-in-out bg-white border border-gray-300 rounded shadow-sm hover:bg-gray-100 focus:border-gray-100 focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed w-full max-w-xs',
            okButton: 'block px-4 py-2 text-white transition duration-100 ease-in-out bg-blue-500 border border-transparent rounded shadow-sm hover:bg-blue-600 focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed w-full max-w-xs',
            inputWrapper: 'mt-3 flex items-center space-x-3',
            input: 'block w-full px-3 py-2 text-black placeholder-gray-400 transition duration-100 ease-in-out bg-white border border-gray-300 rounded shadow-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed w-full',
            select: 'block w-full px-3 py-2 text-black placeholder-gray-400 transition duration-100 ease-in-out bg-white border border-gray-300 rounded shadow-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50  disabled:opacity-50 disabled:cursor-not-allowed w-full',
            radioWrapper: 'flex items-center space-x-2',
            radio: 'text-blue-500 transition duration-100 ease-in-out border-gray-300 shadow-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 focus:ring-offset-0  disabled:opacity-50 disabled:cursor-not-allowed',
            radioText: '',
            checkboxWrapper: 'flex items-center space-x-2',
            checkbox: 'text-blue-500 transition duration-100 ease-in-out border-gray-300 rounded shadow-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 focus:ring-offset-0  disabled:opacity-50 disabled:cursor-not-allowed',
            checkboxText: '',
            errorMessage: 'text-red-500 block text-sm',
            busyWrapper: 'absolute bg-opacity-50 bg-white flex h-full items-center justify-center left-0 top-0 w-full',
            busyIcon: 'animate-spin h-6 w-6 fill-current text-gray-500',
            overlayEnterClass: 'opacity-0',
            overlayEnterActiveClass: 'transition ease-out duration-100',
            overlayEnterToClass: 'opacity-100',
            overlayLeaveClass: 'opacity-100',
            overlayLeaveActiveClass: 'transition ease-in duration-75',
            overlayLeaveToClass: 'opacity-0',
            enterClass: '',
            enterActiveClass: '',
            enterToClass: '',
            leaveClass: '',
            leaveActiveClass: '',
            leaveToClass: ''
          };
        }
      }
    },
    data: function data() {
      return getInitialData(this);
    },
    watch: {
      value: function value(_value) {
        if (_value) {
          this.show();
        } else {
          this.hideReason = HideReason.Value;
          this.close();
        }
      },
      overlayShow: function overlayShow(shown) {
        return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!shown) {
                    _context.next = 8;
                    break;
                  }

                  this.$emit('input', shown);
                  this.$emit('change', shown);
                  _context.next = 5;
                  return this.$nextTick();

                case 5:
                  this.dialogShow = true;
                  _context.next = 9;
                  break;

                case 8:
                  this.closed();

                case 9:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));
      },
      dialogShow: function dialogShow(shown) {
        return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (shown) {
                    _context2.next = 8;
                    break;
                  }

                  this.$emit('input', shown);
                  this.$emit('change', shown);
                  _context2.next = 5;
                  return this.$nextTick();

                case 5:
                  this.overlayShow = false;
                  _context2.next = 9;
                  break;

                case 8:
                  this.opened();

                case 9:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));
      }
    },
    beforeDestroy: function beforeDestroy() {
      var overlay = this.getOverlay();

      if (this.disableBodyScroll && overlay) {
        overlay.focus();
        overlay.enableBodyScroll();
      }
    },
    created: function created() {
      var _this10 = this;

      if (this.name) {
        this.$dialog.$on("show-".concat(this.name), function (resolve, reject) {
          var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
          _this10.resolve = resolve;
          _this10.reject = reject;

          _this10.show(params);
        });
        this.$dialog.$on("hide-".concat(this.name), function () {
          _this10.hideReason = HideReason.Method;

          _this10.close();
        });
      }
    },
    render: function render(createElement) {
      var _this11 = this;

      return createElement('transition', {
        props: {
          enterClass: this.getElementCssClass('overlayEnterClass'),
          enterActiveClass: this.getElementCssClass('overlayEnterActiveClass'),
          enterToClass: this.getElementCssClass('overlayEnterToClass'),
          leaveClass: this.getElementCssClass('overlayLeaveClass'),
          leaveActiveClass: this.getElementCssClass('overlayLeaveActiveClass'),
          leaveToClass: this.getElementCssClass('overlayLeaveToClass')
        }
      }, [createElement(TDialogOverlay, {
        ref: 'overlay',
        props: {
          type: this.type,
          overlayShow: this.overlayShow,
          dialogShow: this.dialogShow,
          titleTag: this.titleTag,
          title: this.title,
          icon: this.icon,
          textTag: this.textTag,
          text: this.text,
          cancelButtonText: this.cancelButtonText,
          cancelButtonAriaLabel: this.cancelButtonAriaLabel,
          okButtonText: this.okButtonText,
          okButtonAriaLabel: this.okButtonAriaLabel,
          showCloseButton: this.showCloseButton,
          preConfirm: this.preConfirm,
          inputAttributes: this.inputAttributes,
          inputType: this.inputType,
          inputValidator: this.inputValidator,
          inputValue: this.inputValue,
          inputOptions: this.inputOptions,
          inputPlaceholder: this.inputPlaceholder,
          getElementCssClass: this.getElementCssClass
        },
        scopedSlots: this.$scopedSlots,
        on: {
          'outside-click': this.outsideClick,
          keyup: this.keyupHandler,
          dismiss: function dismiss(e) {
            return _this11.dismiss(e);
          },
          cancel: function cancel(e) {
            return _this11.cancel(e);
          },
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          submit: function submit(e, input, response) {
            return _this11.submit(e, input, response);
          },
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          'submit-error': function submitError(e, input, error) {
            return _this11.submitError(e, input, error);
          }
        }
      }, this.$slots.default)]);
    },
    methods: {
      getOverlay: function getOverlay() {
        return this.$refs.overlay;
      },
      keyupHandler: function keyupHandler(e) {
        if (e.keyCode === Key$1.ESC && this.escToClose) {
          this.esc(e);
        }
      },
      beforeOpen: function beforeOpen() {
        this.$emit('before-open', {
          params: this.params,
          cancel: this.closeCancel
        });
      },
      opened: function opened() {
        this.$emit('opened', {
          params: this.params
        });
        this.prepareDomForDialog();
      },
      beforeClose: function beforeClose(event) {
        if (this.disableBodyScroll) {
          var overlay = this.getOverlay();

          if (overlay) {
            overlay.focus();
            overlay.enableBodyScroll();
          }
        }

        var beforeCloseParams = {
          cancel: this.closeCancel,
          event: event,
          reason: this.hideReason
        };

        if (this.input !== undefined) {
          beforeCloseParams.input = this.input;
        }

        if (this.preConfirmResponse !== undefined) {
          beforeCloseParams.response = this.preConfirmResponse;
        }

        this.$emit('before-close', beforeCloseParams);
      },
      closed: function closed() {
        var response = {
          hideReason: this.hideReason,
          isOk: this.hideReason === HideReason.Ok,
          isCancel: this.hideReason === HideReason.Cancel,
          isDismissed: typeof this.hideReason === 'string' && [HideReason.Close, HideReason.Esc, HideReason.Outside].includes(this.hideReason)
        };

        if (this.type === DialogType.Prompt && this.hideReason === HideReason.Ok && this.input !== undefined) {
          response.input = this.input;
        }

        if (this.preConfirmResponse !== undefined) {
          response.response = this.preConfirmResponse;
        } else if (this.preConfirmError !== undefined) {
          response.response = this.preConfirmError;
        }

        this.$emit('closed', response);

        if (this.reject && this.preConfirmError !== undefined) {
          this.reject(this.preConfirmError);
        } else if (this.resolve) {
          this.resolve(response);
        }

        this.reset();
      },
      prepareDomForDialog: function prepareDomForDialog() {
        var overlay = this.getOverlay();

        if (!overlay) {
          return;
        }

        if (this.disableBodyScroll) {
          overlay.disableBodyScroll();
        }

        if (this.focusOnOpen) {
          overlay.focus();
        }
      },
      dismiss: function dismiss(e) {
        this.hideReason = HideReason.Close;
        this.close(e);
      },
      esc: function esc(e) {
        this.hideReason = HideReason.Esc;
        this.close(e);
      },
      cancel: function cancel(e) {
        this.hideReason = HideReason.Cancel;
        this.close(e);
      },
      hide: function hide(e) {
        this.hideReason = HideReason.Method;
        this.close(e);
      },
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      submit: function submit(e, input, response) {
        this.hideReason = HideReason.Ok;
        this.input = input;
        this.preConfirmResponse = response;
        this.close(e);
      },
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      submitError: function submitError(e, input, error) {
        this.hideReason = HideReason.Ok;
        this.input = input;
        this.preConfirmError = error;
        this.close(e);
      },
      close: function close(e) {
        this.beforeClose(e);

        if (!this.preventAction) {
          this.dialogShow = false;
        } else {
          this.preventAction = false;
        }
      },
      show: function show() {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
        this.params = params;
        this.beforeOpen();

        if (!this.preventAction) {
          this.overlayShow = true;
        } else {
          this.preventAction = false;
        }
      },
      closeCancel: function closeCancel() {
        this.preventAction = true;
      },
      reset: function reset() {
        Object.assign(this.$data, getInitialData(this));
      },
      outsideClick: function outsideClick(e) {
        if (this.clickToClose) {
          this.hideReason = HideReason.Outside;
          this.close(e);
        }
      }
    }
  });

  var parseDialogOptions = function parseDialogOptions(type, settings, titleOrDialogOptions, text, icon) {
    var props = TDialog.options.props;
    var propsData = Object.assign({
      type: type
    }, settings);
    var target = 'body';

    if (titleOrDialogOptions) {
      if (_typeof(titleOrDialogOptions) === 'object') {
        Object.keys(props).forEach(function (propName) {
          if (propName in titleOrDialogOptions) {
            var defaultValue = get__default['default'](props, "".concat(propName, ".default"));
            propsData[propName] = get__default['default'](titleOrDialogOptions, propName, defaultValue);
          }
        });

        if (titleOrDialogOptions.target) {
          target = titleOrDialogOptions.target;
        }
      } else if (typeof titleOrDialogOptions === 'string') {
        propsData.title = titleOrDialogOptions;

        if (typeof text !== 'undefined') {
          propsData.text = text;
        }

        if (typeof icon !== 'undefined') {
          propsData.icon = icon;
        }
      }
    }

    return {
      propsData: propsData,
      target: target
    };
  };

  var buildDialog = function buildDialog(target, propsData) {
    var domTarget = document.querySelector(target);

    if (!domTarget) {
      throw new Error('Target not found!');
    }

    var instance = new TDialog({
      propsData: propsData
    });
    instance.$mount();
    domTarget.appendChild(instance.$el);
    instance.show();
    return new Promise(function (resolve, reject) {
      instance.resolve = resolve;
      instance.reject = reject;
    });
  };

  var configureDialogGlobals = function configureDialogGlobals(vueInstance, settings) {
    if (!Vue__default['default'].prototype.$dialog) {
      // eslint-disable-next-line no-param-reassign
      vueInstance.prototype.$dialog = new Vue__default['default']({
        methods: {
          alert: function alert(titleOrDialogOptions, text, icon) {
            var _parseDialogOptions = parseDialogOptions(DialogType.Alert, settings, titleOrDialogOptions, text, icon),
                propsData = _parseDialogOptions.propsData,
                target = _parseDialogOptions.target;

            return buildDialog(target, propsData);
          },
          confirm: function confirm(titleOrDialogOptions, text, icon) {
            var _parseDialogOptions2 = parseDialogOptions(DialogType.Confirm, settings, titleOrDialogOptions, text, icon),
                propsData = _parseDialogOptions2.propsData,
                target = _parseDialogOptions2.target;

            return buildDialog(target, propsData);
          },
          prompt: function prompt(titleOrDialogOptions, text, icon) {
            var _parseDialogOptions3 = parseDialogOptions(DialogType.Prompt, settings, titleOrDialogOptions, text, icon),
                propsData = _parseDialogOptions3.propsData,
                target = _parseDialogOptions3.target;

            return buildDialog(target, propsData);
          },
          show: function show(name) {
            var _this12 = this;

            var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
            return new Promise(function (resolve, reject) {
              _this12.$emit("show-".concat(name), resolve, reject, params);
            });
          },
          hide: function hide(name) {
            this.$emit("hide-".concat(name));
          }
        }
      });
    }

    if (!vueInstance.prototype.$alert) {
      // eslint-disable-next-line no-param-reassign
      vueInstance.prototype.$alert = vueInstance.prototype.$dialog.alert; // eslint-disable-next-line no-param-reassign

      vueInstance.prototype.$confirm = vueInstance.prototype.$dialog.confirm; // eslint-disable-next-line no-param-reassign

      vueInstance.prototype.$prompt = vueInstance.prototype.$dialog.prompt;
    }
  };

  var configure = function configure(component, props) {
    var _a, _b;

    var componentProps = (_a = component === null || component === void 0 ? void 0 : component.options) === null || _a === void 0 ? void 0 : _a.props;
    var componentName = (_b = component === null || component === void 0 ? void 0 : component.options) === null || _b === void 0 ? void 0 : _b.name;

    if (componentName === 'TModal') {
      // eslint-disable-next-line no-param-reassign
      Vue__default['default'].prototype.$modal = new Vue__default['default']({
        methods: {
          show: function show(name) {
            var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
            this.$emit("show-".concat(name), params);
          },
          hide: function hide(name) {
            this.$emit("hide-".concat(name));
          }
        }
      });
    } else if (componentName === 'TDialog') {
      configureDialogGlobals(Vue__default['default'], props);
    }

    if (!props || !componentProps) {
      return component;
    }

    var customProps = {};
    Object.keys(props).forEach(function (customPropName) {
      var defaultProp = componentProps[customPropName];

      if (!defaultProp) {
        return;
      }

      var newDefaultValue = props[customPropName];
      customProps[customPropName] = {
        type: defaultProp === null || defaultProp === void 0 ? void 0 : defaultProp.type,
        default: ['object', 'function'].includes(_typeof(newDefaultValue)) ? function () {
          return newDefaultValue;
        } : newDefaultValue
      };
    });
    return component.extend({
      props: customProps
    });
  }; // install function executed by Vue.use()
  // eslint-disable-next-line max-len


  var install = function installVueTailwind(vueInstance, settings) {
    if (install.installed) return;
    install.installed = true; // eslint-disable-next-line no-param-reassign

    vueInstance.prototype.$vueTailwind = true;

    if (!settings) {
      return;
    }

    Object.keys(settings).forEach(function (componentName) {
      var componentSettings = settings[componentName];

      if (typeof componentSettings === 'function' && _typeof(componentSettings.extend) !== undefined) {
        var _component = componentSettings;
        vueInstance.component(componentName, configure(_component));
        return;
      }

      var component = componentSettings.component,
          props = componentSettings.props;
      vueInstance.component(componentName, configure(component, props));
    });
  }; // Create module definition for Vue.use()


  var plugin = {
    install: install
  };
  exports.BaseComponent = Component;
  exports.default = plugin;
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
});